module.exports = __webpack_public_path__ + "static/img/1.05641de.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/7/eng/1.png
// module id = LiWA
// module chunks = 0